import { useNode, useEditor, Element } from "@craftjs/core";
import React, { useState, useEffect, useContext } from "react";
import { DirectorySettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import icon from "./icon";
import { DirectoryTemplate } from "../directory-template";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { GrigoraDashboardContext } from "../../dashboard/context";

export const Directory = (props) => {
  const { cmsPosts } = useContext(GrigoraDashboardContext);
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
    dom,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
    dom: state.dom,
  }));

  const {
    query: { node },
  } = useEditor();

  const [height, setHeight] = useState(50);

  const {
    cmsQuery,
    columns,
    columnsTablet = 1,
    columnsMobile = 1,
    blockGap = "1rem",
    blockGapTablet,
    blockGapMobile,
    textColor,
    backgroundColor,
    typoSize,
    typoLineHeight,
    typoLetterSpacing,
    typoWordSpacing,
    typoWeight,
    typoTransform,
    typoDecoration,
    typoStyle,
    border,
    borderRadius,
    layoutPadding,
    width,
    maxWidth,
    minWidth,
    alignItems,
    boxShadow,
    children,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-directory": true,
      [`directory-${id}`]: id,
    },
    blockProps.className,
  );
  // useEffect(() => {
  //   var templateDom = dom?.querySelector(".g-cms-template");

  //   var heightObserver = new ResizeObserver(() => {
  //     setHeight(templateDom?.offsetHeight);
  //   });

  //   if (templateDom) {
  //     heightObserver.observe(templateDom);
  //   }

  //   return () => {
  //     // Cleanup
  //     if (templateDom) {
  //       heightObserver.unobserve(templateDom);
  //     } else {
  //       heightObserver.disconnect();
  //     }
  //   };
  // }, [dom]);

  const cmsQueryLimit =
    cmsQuery?.limit === undefined || cmsQuery?.limit === null
      ? 10
      : cmsQuery?.limit;

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Directory(id, props)}`}</style>
      <Element
        canvas
        id={`directory-template`}
        is={DirectoryTemplate}
      ></Element>
      {Array.from({
        length: cmsQueryLimit - 1 > 15 ? 14 : cmsQueryLimit - 1,
      }).map((item, index) => {
        return (
          <>
            <div
              style={{
                height: height,
              }}
              key={`g-directory-template-${id}-${index}`}
              className="g-directory-template skeleton"
            ></div>
          </>
        );
      })}
    </div>
  );
};

// To Avoid Mangling in Production
Directory.displayName = "Directory";

Directory.craft = {
  name: "Directory Listings",
  props: {},
  related: {
    settings: DirectorySettings,
    icon: icon,
    category: "directory",
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    supportNestedBlocks: true,
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Directory Listings",
    slug: "grigora/directory",
  },
};
